var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDonut3D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5423 23.0493V26.957L36.0957 29.0133V25.1056L52.5423 23.0493Z",
    fill: "#639CD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6016 9.1123V13.02L25.9177 24.4288V20.5211L21.6016 9.1123Z",
    fill: "#DB4242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0234 8.51465V12.4223L28.0301 24.2323V20.3246L28.0234 8.51465Z",
    fill: "#DB4242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7676 11.6924V15.6001L23.3408 25.2774V21.3697L13.7676 11.6924Z",
    fill: "#127776"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6016 9.11245C23.8079 8.69512 25.7396 8.51529 28.0235 8.51465V12.4223C25.7396 12.423 23.8079 12.6028 21.6016 13.0201V9.11245Z",
    fill: "#DB4242"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.918 20.5214C26.6437 20.3841 27.2792 20.3249 28.0304 20.3247V24.2324C27.2792 24.2326 26.6437 24.2918 25.918 24.429V20.5214Z",
    fill: "#D77575"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6016 9.1123V13.02L25.9178 24.4287V20.521L21.6016 9.1123Z",
    fill: "#127776"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64844 20.0889V23.9966L20.341 28.0396V24.1319L4.64844 20.0889Z",
    fill: "#CBBA3B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7676 11.6924C16.2701 10.4546 18.6513 9.67038 21.6015 9.1123V13.02C18.6513 13.5781 16.2701 14.3623 13.7676 15.6001V11.6924Z",
    fill: "#127776"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3398 21.3702C24.163 20.963 24.9463 20.7051 25.9168 20.5215V24.4292C24.9463 24.6128 24.163 24.8707 23.3398 25.2779V21.3702Z",
    fill: "#4C7BDB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7676 11.6929V15.6006L23.3409 25.2778V21.3702L13.7676 11.6929Z",
    fill: "#CBBA3B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52344 29.1711V33.0788L19.9713 31.0273V27.1196L3.52344 29.1711Z",
    fill: "#D84367"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64844 20.089C6.47882 16.5368 9.3861 13.8599 13.7673 11.6929V15.6006C9.3861 17.7676 6.47882 20.4445 4.64844 23.9967V20.089Z",
    fill: "#CBBA3B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3398 24.132C20.9419 22.9635 21.8983 22.083 23.3395 21.3701V25.2778C21.8983 25.9907 20.9419 26.8712 20.3398 28.0397V24.132Z",
    fill: "#4C7BDB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0273 8.51465V12.4223L28.0307 24.2323V20.3246L28.0273 8.51465Z",
    fill: "#639CD3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0245 39.5992V43.5069L33.293 34.4575V30.5498L44.0245 39.5992Z",
    fill: "#2A2A2F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0273 8.51465C40.2434 8.51289 50.4141 14.5433 52.5411 23.0494V26.9571C50.4141 18.451 40.2434 12.4206 28.0273 12.4223V8.51465Z",
    fill: "#639CD3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0312 20.3247C32.0497 20.3241 35.3953 22.3078 36.095 25.1059V29.0136C35.3953 26.2155 32.0497 24.2318 28.0312 24.2324V20.3247Z",
    fill: "#D77575"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64844 20.0889V23.9966L20.3411 28.0395V24.1318L4.64844 20.0889Z",
    fill: "#D84367"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0332 39.5947V43.5024L22.7698 34.456V30.5483L12.0332 39.5947Z",
    fill: "#676CD0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52291 29.1707C3.25751 28.1068 3.14453 27.1939 3.14453 26.1136V30.0213C3.14453 27.8593 3.60165 26.0279 4.64834 23.9966V20.0889C3.60165 22.1202 3.14453 23.9516 3.14453 26.1136V30.0213C3.14453 31.1016 3.25751 32.0145 3.52291 33.0784V29.1707Z",
    fill: "#4C7BDB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9713 27.1193C19.7093 26.0689 19.8251 25.1339 20.3415 24.1318V28.0395C19.8251 29.0416 19.7093 29.9766 19.9713 31.027V27.1193Z",
    fill: "#FAA3C8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52344 29.1712V33.0789L19.9713 31.0273V27.1196L3.52344 29.1712Z",
    fill: "#676CD0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0273 43.7128V47.6205L28.0307 35.8105V31.9028L28.0273 43.7128Z",
    fill: "#DE8A43"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5424 23.0493V26.957L36.0957 29.0132V25.1055L52.5424 23.0493Z",
    fill: "#2A2A2F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0293 43.7128V47.6205L28.0325 35.8105V31.9028L28.0293 43.7128Z",
    fill: "#77D464"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0343 39.5945C7.35556 36.8181 4.5845 33.4242 3.52344 29.1709V33.0786C4.5845 37.3319 7.35556 40.7258 12.0343 43.5022V39.5945Z",
    fill: "#4C7BDB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7703 30.5485C21.2313 29.6351 20.3197 28.5188 19.9707 27.1196V31.0273C20.3197 32.4264 21.2313 33.5428 22.7703 34.4561V30.5485Z",
    fill: "#676CD0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9222 26.1138C52.9222 31.5156 49.8791 36.1282 44.0254 39.5991V43.5068C49.8791 40.0359 52.9222 35.4233 52.9222 30.0215V26.1138Z",
    fill: "#8377CB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0945 25.106C36.6197 27.2065 35.6045 29.1793 33.293 30.5499V34.4576C35.6045 33.087 36.6197 31.1142 36.0945 29.0137V25.106Z",
    fill: "#6AA4FA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0332 39.5948V43.5025L22.7697 34.456V30.5483L12.0332 39.5948Z",
    fill: "#DE8A43"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0244 39.5993V43.507L33.293 34.4575V30.5498L44.0244 39.5993Z",
    fill: "#77D464"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0276 43.7128C21.9196 43.712 16.7119 42.3711 12.0332 39.5947V43.5024C16.7119 46.2788 21.9196 47.6197 28.0276 47.6205V43.7128Z",
    fill: "#7CC5D3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0308 31.903C26.0216 31.9027 24.3086 31.4616 22.7695 30.5483V34.456C24.3086 35.3693 26.0216 35.8104 28.0308 35.8107V31.903Z",
    fill: "#DE8A43"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M44.026 39.5991C39.3457 42.3742 34.1373 43.7136 28.0293 43.7127V47.6204C34.1373 47.6213 39.3457 46.2819 44.026 43.5068V39.5991Z",
    fill: "#8377CB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2933 30.5498C31.7537 31.4627 30.0405 31.9032 28.0312 31.903V35.8107C30.0405 35.8109 31.7537 35.3704 33.2933 34.4575V30.5498Z",
    fill: "#77D464"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0273 8.51465C40.2434 8.51289 50.4141 14.5433 52.5411 23.0494L36.0945 25.1057C35.3948 22.3077 32.0492 20.324 28.0307 20.3246L28.0273 8.51465Z",
    fill: "#FF878B",
    stroke: "#FF878B",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5412 23.0493C54.1379 29.435 51.0516 35.4322 44.0245 39.5988L33.293 30.5494C35.6045 29.1788 36.6197 27.2061 36.0945 25.1055L52.5412 23.0493Z",
    fill: "#9E8FE9",
    stroke: "#9E8FE9",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M44.026 39.5993C39.3457 42.3744 34.1373 43.7137 28.0293 43.7129L28.0325 31.903C30.0417 31.9032 31.755 31.4627 33.2946 30.5498L44.026 39.5993Z",
    fill: "#9E8FE9",
    stroke: "#9E8FE9",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0276 43.7129C21.9196 43.712 16.7119 42.3712 12.0332 39.5948L22.7697 30.5483C24.3087 31.4616 26.0218 31.9027 28.031 31.903L28.0276 43.7129Z",
    fill: "#7AE0EE",
    stroke: "#7AE0EE",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0343 39.5948C7.35556 36.8184 4.5845 33.4245 3.52344 29.1712L19.9713 27.1196C20.3203 28.5188 21.2318 29.6351 22.7709 30.5485L12.0343 39.5948Z",
    fill: "#5296FC",
    stroke: "#5296FC",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52272 29.1707C2.72621 25.9777 3.07844 23.1353 4.64815 20.0889L20.3408 24.1318C19.8244 25.1339 19.7086 26.0689 19.9706 27.1192L3.52272 29.1707Z",
    fill: "#5296FC",
    stroke: "#5296FC",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64844 20.089C6.47882 16.5368 9.3861 13.8599 13.7673 11.6929L23.3406 21.3702C21.8994 22.083 20.9431 22.9636 20.341 24.132L4.64844 20.089Z",
    fill: "#5296FC",
    stroke: "#5296FC",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7676 11.6924C16.2701 10.4546 18.6513 9.67038 21.6015 9.1123L25.9177 20.521C24.9473 20.7046 24.164 20.9626 23.3408 21.3698L13.7676 11.6924Z",
    fill: "#5296FC",
    stroke: "#5296FC",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6016 9.11245C23.8079 8.69512 25.7396 8.51529 28.0235 8.51465L28.0301 20.3246C27.2789 20.3248 26.6434 20.3839 25.9177 20.5212L21.6016 9.11245Z",
    fill: "#FF878B",
    stroke: "#FF878B",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonut3D);
export default __webpack_public_path__ + "static/media/donut3d.cc5cf504a391bd95c1b3eac0564e0b80.svg";
export { ForwardRef as ReactComponent };